import { Grid, Link, Stack, Typography } from "@mui/material";
import { ButtonBase } from "../../common/components/Button";
import React, { useCallback, useEffect, useState } from "react";
import {
  checkEdsInMydss,
  deleteMydssDocument,
  deleteMydssRegistration,
  mydssGetBlank,
  mydssRegistrationPerson,
  mydssSaveDeviceCode,
  submitMydssSubject,
  uploadMydssDocument,
  uploadMydssRegistrationDocs,
} from "../mydss";
import { IndentSpace, Title5 } from "../../common/components/Typography";
import { exceptionsTitle } from "../../../dictionaries";
import { useNotify } from "../../common/components/AlertNotify";
import {
  getParticipantsSignatures,
  updateMydssParticipantsData,
} from "../../../pages/deal/signatures";
import { FormInputCtrl } from "../../common/components/FormInput";
import { waitInputComplete } from "../../../fn";
import Box from "@mui/material/Box";
import { BlankRow, BoolChip, DocRow, Row } from "./Common";

export const SubjectMydssSignatureComponent = ({ subjectId }) => {
  const [state, setState] = useState(null);

  const loadData = async () => {
    const result = await getParticipantsSignatures({ subjectId });

    if (result) {
      setState(result.mydss);
    }
  };

  useEffect(() => {
    loadData();
  }, []);

  return (
    <Grid container spacing={1} sx={{ width: "552px" }}>
      <Grid item xs={12}>
        <MydssRegInfo subjectId={subjectId} data={state?.precheck} />
      </Grid>
      <Grid item xs={12} style={{ height: 10 }}></Grid>
      <Grid item xs={12}>
        <MydssRegistrationSteps data={state} subjectId={subjectId} />
      </Grid>
      <Grid item xs={12}>
        <SubjectMydssDocUpload
          issueDocs={state}
          subjectId={subjectId}
        ></SubjectMydssDocUpload>
      </Grid>
      <Grid item xs={12} style={{ height: 12 }}></Grid>
      <Grid item xs={12}>
        <UploadDocToCA subjectId={subjectId} data={state} />
      </Grid>
    </Grid>
  );
};

export const MydssRegistrationSteps = ({ data, subjectId }) => {
  const [registering, setRegistering] = useState(false);
  const { openNotify } = useNotify();
  const [values, setValues] = useState(data);
  const [deleting, setDeleting] = useState(false);
  const [blank, setBlank] = useState(false);

  useEffect(() => {
    setValues(data);
  }, [data]);

  const registrationPerson = useCallback(async () => {
    setRegistering(true);
    const result = await mydssRegistrationPerson(subjectId);

    if (result.ok) {
      openNotify({
        msg: "Бланк заявления успешно сформирован",
        duration: 3000,
        type: "success",
      });
    } else {
      openNotify({
        msg:
          exceptionsTitle[result?.message] ||
          result?.message ||
          "Неизвестная ошибка",
        duration: 7000,
        type: "error",
      });
    }

    setRegistering(false);
  });

  const getBlank = useCallback(async () => {
    setBlank(true);
    const result = await mydssGetBlank(subjectId);

    if (result.ok) {
      openNotify({
        msg: "Бланк заявления успешно сформирован",
        duration: 3000,
        type: "success",
      });
      setValues(result.data);
    } else {
      openNotify({
        msg:
          exceptionsTitle[result?.message] ||
          result?.message ||
          "Неизвестная ошибка",
        duration: 7000,
        type: "error",
      });
    }

    setBlank(false);
  });

  const saveDeviceCode = useCallback(async (e) => {
    const result = await mydssSaveDeviceCode(subjectId, e.target.value);

    if (result.ok) {
      updateMydssParticipantsData({
        subjectId,
        data: { deviceCode: e.target.value },
      });
      setValues({ ...values, deviceCode: e.target.value });
    }
  });

  const deleteRegistrationPerson = useCallback(async () => {
    setDeleting(true);
    const result = await deleteMydssRegistration(subjectId);

    if (result.ok) {
      openNotify({
        msg: "Заявка на регистрацию успешно удалена",
        duration: 1000,
        type: "success",
      });
    } else {
      openNotify({
        msg:
          exceptionsTitle[result?.message] ||
          result?.message ||
          "Неизвестная ошибка",
        duration: 7000,
        type: "error",
      });
    }

    setDeleting(false);
  });

  const waitSaveDeviceCode = waitInputComplete(saveDeviceCode, 500);

  const blanks = [
    {
      label: "Бланк запроса на выдачу сертификата",
      href: values?.certRequestBlank,
    },
    {
      label: "Бланк сертификата ключа проверки электронной подписи",
      href: values?.certBlank,
    },
    { label: "Бланк согласия на обработку ПД", href: values?.sopdBlank },
  ].filter((b) => Boolean(b.href));

  return (
    <Grid container spacing={1}>
      <Grid item xs={12} sx={{ pb: 2 }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <FormInputCtrl
            label="Введите код устройства"
            required
            onChange={waitSaveDeviceCode}
            value={values?.deviceCode}
          />
          <ButtonBase
            variant="contained"
            size="small"
            disabled={!values?.deviceCode?.length}
          >
            <Link
              href="#"
              color="inherit"
              onClick={registrationPerson}
              sx={{ textDecoration: "none", fontSize: 12 }}
            >
              {registering ? "Регистрация ..." : "Зарегистрировать"}
            </Link>
          </ButtonBase>
        </Box>
      </Grid>
      <Grid
        item
        xs={12}
        sx={{ height: 10, borderTop: "1px solid", borderColor: "grey.100" }}
      />
      <Grid item xs={12}>
        <ButtonBase
          variant="contained"
          size="small"
          disabled={!values?.deviceCode?.length}
          color="success"
        >
          <Link
            href="#"
            color="inherit"
            onClick={getBlank}
            sx={{ textDecoration: "none", fontSize: 12 }}
          >
            {blank ? "Идёт запрос ..." : "Запросить бланк"}
          </Link>
        </ButtonBase>
        <IndentSpace size={10} />
        <ButtonBase variant="contained" color="error" size="small">
          <Link
            href="#"
            color="inherit"
            onClick={deleteRegistrationPerson}
            sx={{ textDecoration: "none", fontSize: 12 }}
          >
            {deleting ? "Удаление ..." : "Удалить заявку"}
          </Link>
        </ButtonBase>
      </Grid>
      <Grid item xs={12}>
        {blanks.map((b, idx) => (
          <BlankRow key={b.href} {...b} isLast={idx === blanks.length - 1} />
        ))}
      </Grid>
    </Grid>
  );
};

export const MydssRegInfo = ({ subjectId, data }) => {
  const [values, setValues] = useState(data);
  const [prechecking, setPrechecking] = useState(false);
  const { openNotify } = useNotify();

  useEffect(() => {
    setValues(data);
  }, [data]);

  const precheck = async () => {
    setPrechecking(true);
    const result = await checkEdsInMydss(subjectId);

    if (!result.ok) {
      openNotify({
        msg:
          exceptionsTitle[result?.message] ||
          result?.message ||
          "Неизвестная ошибка",
        duration: 7000,
        type: "error",
      });
    } else {
      setValues(result.data);
    }
    setPrechecking(false);
  };

  const { activeApplication } = values || { activeApplication: null };

  const rows = values
    ? [
        {
          label: "Запросил бланк на регистрацию",
          valueEl: <BoolChip value={values?.hasActiveApplications} />,
        },
        {
          label: "Имеет ЭП",
          valueEl: <BoolChip value={values?.hasActiveCertificates} />,
        },
        activeApplication?.status && {
          label: "Статус рассмотрения",
          value: activeApplication.status,
        },
        activeApplication?.description && {
          label: "Ответ УЦ",
          value: `«${activeApplication.description}»`,
        },
      ].filter(Boolean)
    : [];

  return (
    <Box sx={{ maxWidth: 500 }}>
      <Box item xs={12}>
        <ButtonBase variant="contained" color="success" size="small">
          <Link
            href="#"
            color="inherit"
            onClick={precheck}
            sx={{
              textDecoration: "none",
              fontSize: 12,
            }}
          >
            {prechecking
              ? "Идёт запрос данных ..."
              : "Проверить регистрацию и ЭП"}
          </Link>
        </ButtonBase>
      </Box>

      {rows.length > 0 ? (
        <Stack
          divider={
            <Box sx={{ borderTop: "1px solid", borderColor: "grey.100" }} />
          }
        >
          {rows.map((row, i) => (
            <Row key={i} {...row} />
          ))}
        </Stack>
      ) : (
        <Typography variant="body2" sx={{ color: "text.disabled", py: 1 }}>
          Нажмите «Проверить» для получения данных
        </Typography>
      )}
    </Box>
  );
};

const SubjectMydssDocUpload = ({ issueDocs, subjectId }) => {
  const [state, setState] = useState(issueDocs || {});
  const [loadingIcon, setLoadingIcon] = useState({
    union: false,
    soglasiePdn: false,
    passportphoto: false,
    passportfacephoto: false,
    additional: false,
    snils: false,
  });

  const { openNotify } = useNotify();

  useEffect(() => {
    setState(issueDocs || {});
  }, [issueDocs]);

  const documentFields = [
    {
      label: "Запрос на выдачу сертификата",
      field: "certRequest",
      required: true,
    },
    { label: "Бланк сертификата ключа", field: "certBlankKey", required: true },
    { label: "Согласие на обработку ПД", field: "soglasiePdn", required: true },
    { label: "Паспорт", field: "passportphoto", required: true },
    { label: "Паспорт прописка", field: "passportadrphoto", required: true },
    {
      label: "Клиент с паспортом и заявлением",
      field: "passportfacephoto",
      required: true,
    },
    { label: "СНИЛС", field: "snils", required: true },
    { label: "Прочие документы", field: "additional", required: false },
  ];

  const handleUploadResult = useCallback(
    async (docType, event) => {
      setLoadingIcon((prev) => ({ ...prev, [docType]: true }));

      const result = await uploadMydssDocument(
        docType,
        event.formData,
        subjectId
      );

      if (result.ok) {
        setState((prev) => ({ ...prev, ...result.data }));
        updateMydssParticipantsData({ subjectId, data: { ...result.data } });
      } else {
        openNotify({
          errors: result.errors,
          msg: exceptionsTitle[result.message] || "Не удалось загрузить файл",
          duration: 5000,
          type: "error",
        });
      }
      setLoadingIcon((prev) => ({ ...prev, [docType]: false }));
    },
    [subjectId]
  );

  const onDelete = useCallback(
    async (docType) => {
      const result = await deleteMydssDocument(docType, subjectId);

      if (result) {
        const dtlink = `${docType}Link`;
        setState((prev) => {
          const newState = { ...prev };
          delete newState[docType];
          delete newState[dtlink];
          return newState;
        });

        updateMydssParticipantsData({
          subjectId,
          data: { [dtlink]: "", [docType]: "" },
        });
      }
    },
    [subjectId]
  );

  return (
    <>
      <Box sx={{ borderTop: "1px solid", borderColor: "grey.100" }} />
      {/* Header */}
      <Box sx={{ pt: 2 }}>
        <Title5 title="Документы" />
      </Box>

      {/* Rows */}
      {documentFields.map((f, idx) => (
        <DocRow
          key={f.field}
          {...f}
          fileName={state?.[f.field]}
          fileLink={state?.[`${f.field}Link`]}
          isLoading={loadingIcon[f.field]}
          onUpload={handleUploadResult}
          onDelete={onDelete}
          isLast={idx === documentFields.length - 1}
        />
      ))}
    </>
  );
};

const UploadDocToCA = ({ subjectId, data }) => {
  const [uploading, setUploading] = useState(false);
  const [activating, setActivating] = useState(false);
  const { openNotify } = useNotify();

  const uploadRegistrationDocuments = useCallback(async () => {
    setUploading(true);
    const result = await uploadMydssRegistrationDocs(subjectId);

    if (result.ok) {
      updateMydssParticipantsData({
        subjectId,
        data: { documentsAlreadySentToCA: true },
      });
      openNotify({
        msg: "Документы успешно отправлены",
        duration: 2000,
        type: "success",
      });
    } else {
      openNotify({
        msg: exceptionsTitle[result?.message] || "Ошибка отправки документов",
        duration: 3000,
        type: "error",
      });
    }
    setUploading(false);
  });

  const activatePerson = useCallback(async () => {
    setUploading(true);
    const result = await submitMydssSubject(subjectId);

    if (result.ok) {
      openNotify({
        msg: "Пользователь успешно активирован",
        duration: 2000,
        type: "success",
      });
    } else {
      openNotify({
        msg:
          exceptionsTitle[result?.message] || "Ошибка активации пользователя",
        duration: 3000,
        type: "error",
      });
    }
    setUploading(false);
  });

  return (
    <>
      <ButtonBase variant="contained" size="small">
        <Link
          href="#"
          color="inherit"
          onClick={uploadRegistrationDocuments}
          sx={{ textDecoration: "none", fontSize: 12 }}
        >
          {uploading ? "Идёт отправка ..." : "Отправить в УЦ"}
        </Link>
      </ButtonBase>
      <IndentSpace size={10} />
      <ButtonBase
        variant="contained"
        color="warning"
        size="small"
        disabled={!data?.documentsAlreadySentToCA}
      >
        <Link
          href="#"
          color="inherit"
          onClick={activatePerson}
          sx={{
            textDecoration: "none",
            fontSize: 12,
          }}
        >
          {activating ? "Активация ..." : "Подтвердить пользователя"}
        </Link>
      </ButtonBase>
    </>
  );
};

